import React from 'react';
import MemberManagement from "../../members/members";

export default function MembersTab(props){
	const  { partner: { ooid = '', partnerType ='marketplace', orgName='' }  } = props;
	return <MemberManagement
		ooid={ooid}
		adminView={true}
		partnerType={partnerType}
		role={'ADMIN'}
		orgName={orgName}
	/>
}

